// extracted by mini-css-extract-plugin
export default {"row":"Home_row__gB1x-","col":"Home_col__gYUz7","card":"Home_card__pPsB9"};